// components/TopBar.js
import React from 'react';
import { Menu, X } from 'lucide-react';

function TopBar({ user, onLogout, onToggleSidebar, sidebarOpen }) {
  return (
    <div className="top-bar">
      <button className="menu-toggle" onClick={onToggleSidebar}>
        {sidebarOpen ? <X size={24} /> : <Menu size={24} />}
      </button>
      
      <div className="user-info">
        <span>Welcome, {user}</span>
        <div className="user-avatar">
          {user.charAt(0).toUpperCase()}
        </div>
        <button onClick={onLogout} className="btn btn-secondary">
          Logout
        </button>
      </div>
    </div>
  );
}

export default TopBar;